import React from 'react';

import ListPageHeader from '@shared/ListPageHeader';
import ProductSerialNumberList from '@shared/product_serial_numbers/ProductSerialNumberList';

import { useAdminProductSerialNumberService } from '@hooks/admin/product_serial_numbers/useAdminProductSerialNumberService';
import { useAdminProductService } from '@hooks/admin/products/useAdminProductService';

/**
 * Admin Product Serial Numbers — 序號 (PSN) identity-centric 列表頁。
 *
 * 直接使用 shared/product_serial_numbers/ProductSerialNumberList，
 * 透過 useAdminProductSerialNumberService 注入 service。
 * 同步注入 useAdminProductService 讓「商品多選 filter」(lazyLoad) 出現。
 *
 * 麵包屑 / 標題 透過 ListPageHeader 自動由 menuConfig 的 labelKey 產生。
 */
const AdminProductSerialNumbersList: React.FC = () => {
  const service = useAdminProductSerialNumberService();
  const productService = useAdminProductService();

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['products', 'products.serial_numbers']}
      />
      <ProductSerialNumberList
        role="admin"
        service={service}
        productService={productService}
      />
    </div>
  );
};

export default AdminProductSerialNumbersList;
